import { SVGProps } from "react";

const RemoveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 20}
    height={props.width || 17}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.93343 18.3333C14.5168 18.3333 18.2668 14.5833 18.2668 10C18.2668 5.41667 14.5168 1.66667 9.93343 1.66667C5.3501 1.66667 1.6001 5.41667 1.6001 10C1.6001 14.5833 5.3501 18.3333 9.93343 18.3333Z"
      stroke="#FE3939"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6001 10H13.2668"
      stroke="#FE3939"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default RemoveIcon;
